import Collapsible from '@/components/ui/collapsible'
import Button from '@/components/ui/button'
import ReactMarkdown from 'react-markdown'

function FaqComponent({ faq, className }) {
  return (
    <ul className={className}>
      {faq.items?.map(({ id, question, answer }) => {
        return (
          <li
            key={id}
            className="w-full border transition duration-150 ease-out -mb-px border-gray-20 hover:border-gray-50 first:rounded-t last:rounded-b"
          >
            <Collapsible
              isFullWidth
              trigger={
                <Button
                  className="flex items-center w-full p-25 font-bold cursor-pointer text-left"
                  unstyled
                >
                  {question}
                </Button>
              }
            >
              <div className="pb-25 px-25 text-14">
                <ReactMarkdown
                  components={{
                    p: ({ children }) => <p className="mb-10">{children}</p>,
                    h2: ({ children }) => (
                      <h2 className="title-3 mt-30 mb-10">{children}</h2>
                    ),
                    h3: ({ children }) => (
                      <h3 className="title-4 mt-30 mb-10">{children}</h3>
                    ),
                    ol: ({ children }) => (
                      <ol className="mb-10 list-decimal list-inside">
                        {children}
                      </ol>
                    ),
                    ul: ({ children }) => (
                      <ul className="mb-10 list-disc list-inside">
                        {children}
                      </ul>
                    ),
                    a: ({ children, href }) => (
                      <a
                        className="underline hover:no-underline"
                        href={href}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {children}
                      </a>
                    ),
                  }}
                >
                  {answer}
                </ReactMarkdown>
              </div>
            </Collapsible>
          </li>
        )
      })}
    </ul>
  )
}

export default FaqComponent
